import { FC, useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import Data from '../../assets/data-two.json'
// import CountUp, { useCountUp } from 'react-countup'
// import Counter from '../Counter'

const isMobile = window.innerWidth < 599

interface ChapterProps {
  colorMode?: 'light' | 'dark' | undefined
  tenant: Tenant
  headerHeight?: number
}

const ChapterTwo: FC<ChapterProps> = ({ colorMode, tenant, headerHeight }) => {
  // State to store the active title index
  const [activeChapterIndex, setActiveChapterIndex] = useState<number>(0)
  const addPadding = activeChapterIndex < Data.length - 1

  //   console.log('index', activeChapterIndex)

  // Ref to store all our title refs
  const ref = useRef<(HTMLDivElement | null)[]>([])

  // Function to add elements to our refs array
  const addToRefs = (el: any) => {
    if (el && !ref.current.includes(el)) {
      ref.current.push(el)
    }
  }

  // Assuming that Data and activeChapterIndex are available in this scope

  let allDivs: React.ReactNode[] = []
  Data[activeChapterIndex].chartCircles &&
    Data[activeChapterIndex].chartCircles.forEach((item, index) => {
      for (let i = 0; i < item.value; i++) {
        allDivs.push(
          <div
            key={`${index}-${i}`}
            className='circle'
            style={{ backgroundColor: colorMode === 'dark' ? item.colorDark : item.color}}
          />
        )
      }
    })

  // Then, map over 'allDivs', grouping into rows of at most 10 divs
  let allRows = []
  for (let i = 0; i < allDivs.length; i += 10) {
    const rowItems = allDivs.slice(i, i + 10)
    allRows.push(
      <div key={i} className='row-container'>
        {rowItems}
      </div>
    )
  }

  useEffect(() => {
    // This is the callback that gets invoked whenever an observed entry intersects with the viewport
    const observerCallback = (entries: any, observer: any) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          const titleIndex = parseInt(
            entry.target.getAttribute('data-index'),
            10
          )
          setActiveChapterIndex(titleIndex)
        }
      })
    }

    const current = ref.current

    console.log('headerHeight', headerHeight)

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }

    // Instantiate IntersectionObserver
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    if (ref.current) {
      ref.current.forEach((el) => {
        if (el !== null) {
          observer.observe(el)
        }
      })
    }

    return () => {
      if (current) {
        current.forEach((el) => {
          if (el) {
            observer.unobserve(el)
          }
        })
      }
    }
  }, [])

  return (
    <ChapterWrapper>
      <StickyElement
        headerHeight={headerHeight}
        addPadding={addPadding}
        className={colorMode === 'dark' ? 'dark' : ''}
      >
        {/* <Counter value={Data[activeChapterIndex].absolutNumber}  previousValue={Data[activeChapterIndex - 1]?.absolutNumber} nextValue={Data[activeChapterIndex - 1]?.absolutNumber}></Counter> */}
        <AbsolutNumberWrapper>
          <div>
            {' '}
            <div className='title'>{Data[activeChapterIndex].chartTitle}:&nbsp;</div>
            <div className='number'>
              {Data[activeChapterIndex].absolutNumber}
            </div>
          </div>
        </AbsolutNumberWrapper>
        <ChartWrapper>
          {Data[activeChapterIndex].chartAnnotations &&
            Data[activeChapterIndex].chartAnnotations?.map((obj, i) => (
              <div
                key={i}
                style={{
                  top: isMobile
                    ? obj.positionTopMobile + '%'
                    : obj.positionTop + '%',
                }}
                className='annotation'
              >
                {Array.isArray(obj.text) &&
                  obj.text.map((item: string, i: number) => {
                    const className = item
                      .split(':')[0]
                      .replace(/&shy;/g, '')
                      .trim() // This will get the string before ":"
                    return (
                      <>
                        <span
                          key={i}
                          className={colorMode === 'dark' ? (className + ' dark') : (className)}
                          dangerouslySetInnerHTML={{ __html: item }}
                        />
                        {i < obj.text.length - 1 && ', '}
                      </>
                    )
                  })}
              </div>
            ))}
          {allRows}
        </ChartWrapper>
      </StickyElement>

      {Data &&
        Data.map((chapter: any, index: number) => {
          return (
            <>
              <TextWrapper className={index === 0 ? 'first' : ''}>
                <div>
                  <Title
                    key={index}
                    ref={addToRefs} // Add ref to each title
                    data-index={index}
                    className={colorMode === 'dark' ? 'dark' : ''}
                  >
                    {chapter.chapterTitle}
                  </Title>
                  <div
                    dangerouslySetInnerHTML={{ __html: chapter.htmlParagraph }}
                  />
                </div>
              </TextWrapper>
            </>
          )
        })}
    </ChapterWrapper>
  )
}

const ChapterWrapper = styled.div`
  width: 100%;
`

const StickyElement = styled.div<{
  headerHeight?: number
  addPadding: boolean
}>`
  position: sticky;
  top: ${({ headerHeight }) => headerHeight ?? 0}px;
  /* width: 100%; */
  padding: 2rem 0;
  /* padding-bottom: ${(props) => (props.addPadding ? '57px' : '15px')}; */
  background-color: var(--site-background);
  box-shadow: 0px 10px 10px -8px rgba(0, 0, 0, 0.05);
  &.dark {
    box-shadow: rgb(48 45 45) 0px 10px 10px -8px;
  }
  /* @media only screen and (min-width: 600px) {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  padding: 1em 1.5em;
  border-radius: 5px;
  } */
  @media only screen and (max-width: 599px) {
    /*  */
  }
`

const TextWrapper = styled.div`
  height: 100vh;
  font-family: var(--font-serif);
  display: inline-block;

  &.first > div {
    padding-top: 2em;
  }

  /* >div {
    padding: 1em 1em;
    background-color: #F0F0F2;
  } */

  /* styles */
`

const Title = styled.h4`
  font-family: var(--font-sans-serif);

  ::before {
    display: block;
    order: -2;
    width: 6rem;
    margin: 0 auto 4rem;
    border-bottom: 2px solid var(--gray-4);
    content: '';
  }
  &.dark::before {
    border-bottom: 2px solid var(--gray-2);
  }
  margin-top: 2em;

  font-size: 1em;
  line-height: 2.6rem;
`

const AbsolutNumberWrapper = styled.div`
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  flex-direction: row;
  align-items: center;

  //set minheight to the height of number
  min-height: 22px;
  line-height: 1em;
  margin-bottom: 1.125rem;

  div {
    display: flex;
    align-items: baseline;
  }

  .number {
    font-size: 1.2em;
    /* margin-left: 0.75rem; */
    @media only screen and (max-width: 599px) {
      font-size: 1.1em;
    }
  }
  .title {
    font-size: 1.5rem;
    font-weight: 600;
    @media only screen and (max-width: 599px) {
      font-size: 1.5rem;
    }
  }
  /* styles */
`

// const BylineWrapper = styled.div`
//   display: flex;
//   /* margin-top: 1rem; */

//   .bar {
//     position: relative;
//     box-sizing: border-box;
//     &.byline {
//       font-size: 1.2rem;
//       height: 12px;
//       display: flex;
//       line-height: 1.2em;
//       /* margin: 0.75em 0; */
//       letter-spacing: 0.25px;
//     }

//     &.byline.top {
//       align-self: self-end;
//       padding-left: 0.5rem;
//     }

//     &.byline.bottom {
//       align-self: self-start;
//       position: relative;
//       padding-left: 0.5rem;

//       span {
//         margin-top: -1em;
//       }
//     }

//     &.byline.top:nth-child(odd) {
//       --stroke-color: var(--site-background);
//       --stroke-width: 2px;
//       letter-spacing: 0.5px;
//       color: var(--text-color);
//       text-shadow: var(--stroke-width) 0 0 var(--stroke-color),
//         calc(var(--stroke-width) * -1) 0 0 var(--stroke-color),
//         0 var(--stroke-width) 0 var(--stroke-color),
//         0 calc(var(--stroke-width) * -1) 0 var(--stroke-color);

//       text-shadow: calc(var(--stroke-width) * 1) calc(var(--stroke-width) * 0) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * 0.3827) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * 0.7071) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * 0.9239) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0) calc(var(--stroke-width) * 1) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * 0.9239) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * 0.7071) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * 0.3827) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -1) calc(var(--stroke-width) * 0) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * -0.3827)
//           0 var(--stroke-color),
//         calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * -0.7071)
//           0 var(--stroke-color),
//         calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * -0.9239)
//           0 var(--stroke-color),
//         calc(var(--stroke-width) * 0) calc(var(--stroke-width) * -1) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * -0.9239) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * -0.7071) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * -0.3827) 0
//           var(--stroke-color);
//     }

//     &.byline.bottom:nth-child(even) {
//       --stroke-color: var(--site-background);
//       --stroke-width: 2px;
//       letter-spacing: 0.5px;
//       color: var(--text-color);
//       text-shadow: var(--stroke-width) 0 0 var(--stroke-color),
//         calc(var(--stroke-width) * -1) 0 0 var(--stroke-color),
//         0 var(--stroke-width) 0 var(--stroke-color),
//         0 calc(var(--stroke-width) * -1) 0 var(--stroke-color);

//       text-shadow: calc(var(--stroke-width) * 1) calc(var(--stroke-width) * 0) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * 0.3827) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * 0.7071) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * 0.9239) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0) calc(var(--stroke-width) * 1) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * 0.9239) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * 0.7071) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * 0.3827) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -1) calc(var(--stroke-width) * 0) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * -0.3827)
//           0 var(--stroke-color),
//         calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * -0.7071)
//           0 var(--stroke-color),
//         calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * -0.9239)
//           0 var(--stroke-color),
//         calc(var(--stroke-width) * 0) calc(var(--stroke-width) * -1) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * -0.9239) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * -0.7071) 0
//           var(--stroke-color),
//         calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * -0.3827) 0
//           var(--stroke-color);
//     }
//   }
// `

const ChartWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;

  div.annotation {
    font-size: 0.8em;
    left: calc(50% + 115px);
    position: absolute;
    line-height: 1.3em;
    font-size: 1.5rem;
    /* font-weight: 600; */
    .Nichtwählende,
    .Nicht.Wahlberechtigte {
      color: #9698a8;
      &.dark {
        color: rgba(255, 255, 255, 0.4);
      }
    }
    .SVP {
      color: #4b8a3e;
    }
    .SP {
      color: #f0554d;
    }
    .Mitte {
      color: #d6862b;
    }
    .FDP {
      color: #3872b5;
    }
    .GPS {
      color: #84b547;
    }
    .GLP {
      color: #c4c43d;
    }
    .Andere {
      color: #7d7d7d;
    }

    .number {
      font-weight: 300;
    }
    @media only screen and (max-width: 599px) {
      font-size: 1.2rem;
      left: calc(50% + 80px);
      margin-top: 1.5em;
    }
  }
  .row-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .circle {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
    margin: 0.25rem;
    @media only screen and (max-width: 599px) {
      margin: 0.25rem;
      width: 9px;
      height: 9px;
    }
  }
`

export default ChapterTwo
